import { clsx } from "clsx"
import type { ClassValue } from "clsx"
import { extendTailwindMerge } from "tailwind-merge"

export * from "class-variance-authority"

// The retuned type scale adds font-size utilities tailwind-merge cannot
// classify. Unlisted, they land in the text-colour group, so a size class
// swallows a colour class in the same string — `text-label` (Badge sm)
// erased `text-primary`.
//
// The named spacing tokens in theme.css (control heights, icon sizes, the
// badge, track and field insets) are unknown to it too, so `h-control-xs`
// never replaced a component's `h-control-xl` and a call site had to reach
// for `!`. Keep this list in step with the `--spacing-*` tokens.
const twMerge = extendTailwindMerge({
  extend: {
    classGroups: {
      "font-size": ["text-2xs", "text-label", "text-mono-xs"],
    },
    theme: {
      spacing: [
        "control-xs",
        "control-sm",
        "control-md",
        "control",
        "control-lg",
        "control-xl",
        "control-2xl",
        "control-pad-sm",
        "control-pad",
        "control-pad-lg",
        "control-pad-xl",
        "control-block",
        "badge-x",
        "badge-y",
        "badge-y-sm",
        "badge-y-lg",
        "track",
        "track-sm",
        "card",
        "tight",
        "icon-3xs",
        "icon-2xs",
        "icon-xs",
        "icon-sm",
        "icon",
        "icon-lg",
        "icon-xl",
        "textarea-sm",
        "textarea",
        "textarea-lg",
        "field",
        "popover",
      ],
    },
  },
})

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}
